import React, { ReactNode } from "react";
import {
  Box,
  Flex,
  Image,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import payBg from "@/assets/images/payment/default_modal_bg.png";
import RocketSuccessPng from "@/assets/images/payment/pay_rocket.png";
import { mdScale } from "@/stores/theme";

interface Props {
  isOpen: boolean;
  onClose(): void;
  title: string | ReactNode;
  info?: string;
  contentImage?: string;
  imageDesc: string;
  footerText: string;
  onBtnClick(): void;
  modalBgImage?: string;
  btnText?: string;
}

const goldGradient = `linear-gradient(#FEF5DA, #E6C48C);`;

export default function PaySuccessModal(props: Props) {
  const {
    isOpen,
    onClose,
    title,
    info,
    contentImage = RocketSuccessPng,
    imageDesc,
    footerText,
    onBtnClick,
    modalBgImage = payBg,
    btnText = "我知道了",
  } = props;
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        pos="relative"
        zIndex={0}
        maxW={{ base: `${400 * mdScale}px`, lg: `${400}px` }}
        maxH={{ base: `${600 * mdScale}px`, lg: `${600}px` }}
        rounded={{ base: `${20 * mdScale}px`, lg: `${20}px` }}
        bgColor="#404040"
        overflow="hidden"
      >
        {modalBgImage ? (
          <Image zIndex={-1} pos="absolute" w="100%" left="0" top="0" src={modalBgImage} />
        ) : null}
        <ModalCloseButton color="white" />
        <Flex
          w={{ base: `${400 * mdScale}px`, lg: `${400}px` }}
          h={{ base: `${600 * mdScale}px`, lg: `${600}px` }}
          flexDir="column"
          color="white"
          align="center"
          py={{ base: `${48 * mdScale}px`, lg: `${48}px` }}
        >
          {typeof title === "string" ? (
            <Text
              fontWeight={600}
              fontSize={{ base: `${36 * mdScale}px`, lg: `${36}px` }}
              bg={goldGradient}
              bgClip="text"
            >
              {title}
            </Text>
          ) : (
            title
          )}
          <Text
            mt={{ base: `${14 * mdScale}px`, lg: `${14}px` }}
            fontSize={{ base: `${14 * mdScale}px`, lg: `${14}px` }}
            color="#FEF5DA"
          >
            {info ?? null}
          </Text>
          <Image
            mt={{ base: `${75 * mdScale}px`, lg: `${75}px` }}
            w={{ base: `${249 * mdScale}px`, lg: `${240}px` }}
            src={contentImage}
          />
          <Text
            mt={{ base: `${35 * mdScale}px`, lg: `${35}px` }}
            fontSize={{ base: `${24 * mdScale}px`, lg: `${24}px` }}
            color="black"
            fontWeight={600}
          >
            {imageDesc}
          </Text>
          <Text color="#999999" fontSize={{ base: `${12 * mdScale}px`, lg: `${12}px` }}>
            {footerText}
          </Text>
          <Flex
            as="button"
            mt={{ base: `${16 * mdScale}px`, lg: `${16}px` }}
            w={{ base: `${216 * mdScale}px`, lg: `${216}px` }}
            h={{ base: `${50 * mdScale}px`, lg: `${50}px` }}
            rounded="full"
            align="center"
            justify="center"
            bg={goldGradient}
            onClick={onBtnClick}
          >
            <Text
              color="black"
              fontSize={{ base: `${24 * mdScale * mdScale}px`, lg: `${24}px` }}
              fontWeight={500}
            >
              {btnText}
            </Text>
          </Flex>
        </Flex>
      </ModalContent>
    </Modal>
  );
}
